import { LocalizedLabelInterface } from "../interfaces/LocalizedLabelInterface";

export const getLocalizedText = (
    label: LocalizedLabelInterface | string,
): string => {
    if (typeof label === "string") return label;
    return label?.en_AU || "";
};
